<template>
  <div class=".received-requests">
    <div
      style="
        box-shadow: 0px 0px 6px -4px black;
        background: white;
        border-radius: 10px;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        margin-top: 20px;
      "
      class="btns-dad"
    >
      <v-switch
        v-model="readyToRecieve"
        :label="readyLable"
        :color="$vuetify.theme.themes.light.dataActionBTN"
        :value="readyToRecieve"
        hide-details
        :disabled="disabledBtn"
        @change="switchReadyState"
        class="mt-0"
      ></v-switch>
      <v-btn
        :color="$vuetify.theme.themes.light.dataActionBTN"
        style="font-size: 16px"
        class="pb-2 receive-btn"
        @click="ask_for_more_customers"
        dark
        >اطلب مزيد من العملاء!</v-btn
      >
      <v-btn
        :color="$vuetify.theme.themes.light.dataActionBTN"
        :style="showBtn ? 'font-size: 16px' : 'display:none'"
        class="pb-2 receive-btn"
        @click="toggleTables"
        dark
        >{{ showBtnText }}</v-btn
      >
    </div>

    <v-btn
      fab
      :color="$vuetify.theme.themes.light.dialogActionBTN"
      @click="addNewRequestDialog = true"
      class="my-10"
      style="position: fixed; left: 20px; bottom: 30px; z-index: 2"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25.425"
        height="21.166"
        viewBox="0 0 25.425 21.166"
      >
        <g
          id="Icon_feather-user-plus"
          data-name="Icon feather-user-plus"
          transform="translate(1 1)"
        >
          <path
            id="Path_2554"
            data-name="Path 2554"
            d="M17.471,28.889v-2.13A4.259,4.259,0,0,0,13.212,22.5H5.759A4.259,4.259,0,0,0,1.5,26.759v2.13"
            transform="translate(-1.5 -9.723)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Path_2555"
            data-name="Path 2555"
            d="M15.268,8.759A4.259,4.259,0,1,1,11.009,4.5,4.259,4.259,0,0,1,15.268,8.759Z"
            transform="translate(-3.023 -4.5)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Path_2556"
            data-name="Path 2556"
            d="M30,12v6.389"
            transform="translate(-9.77 -6.676)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Path_2557"
            data-name="Path 2557"
            d="M31.889,16.5H25.5"
            transform="translate(-8.464 -7.982)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </g>
      </svg>
    </v-btn>
    <add-new-request
      v-model="addNewRequestDialog"
      width="350px"
      @submitted="get_all_requests"
    />

    <!--Received SMRequests Table-->
    <div :class="showTable == 1 ? 'mt-6' : 'mt-6 d-none'">
      <h3 v-if="$store.state.views !== 'default'">الطلبات المستلمة :</h3>
      <div
        v-if="$store.state.views !== 'default'"
        class="printing mb-3"
        style="
          background: white;
          padding: 10px;
          justify-content: center;
          box-shadow: 0px 0px 6px -4px black;
          border-radius: 10px;
        "
        :style="items.length <= 0 ? 'display:none' : 'display:flex'"
      >
        <div>
          <v-btn
            depressed
            width="45"
            height="45"
            :color="$vuetify.theme.themes.light.dataActionBTN"
            dark
            fab
            class="ml-1 hidden-sm-and-down"
            @click="exportExcel"
            v-if="$store.state.views != 'cards'"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.116"
              height="18.116"
              viewBox="0 0 12.25 14"
            >
              <g id="excel-file" transform="translate(-1.5)">
                <path
                  id="Path_4097"
                  data-name="Path 4097"
                  d="M11.708,14H1.792a.292.292,0,0,1-.292-.292V3.548a.292.292,0,0,1,.074-.194L4.491.1A.292.292,0,0,1,4.708,0h7A.292.292,0,0,1,12,.292V7a.292.292,0,0,1-.583,0V.583H4.839L2.083,3.659v9.757h9.333V12.25a.292.292,0,1,1,.583,0v1.458A.293.293,0,0,1,11.708,14Z"
                  fill="#fff"
                />
                <path
                  id="Path_4098"
                  data-name="Path 4098"
                  d="M4.917,4.292H2.292a.292.292,0,0,1,0-.583H4.625V.792a.292.292,0,0,1,.583,0V4A.292.292,0,0,1,4.917,4.292Zm8.167,8.167h-7a.876.876,0,0,1-.875-.875v-3.5a.876.876,0,0,1,.875-.875h7a.876.876,0,0,1,.875.875v3.5A.876.876,0,0,1,13.083,12.458Zm-7-4.667a.292.292,0,0,0-.292.292v3.5a.292.292,0,0,0,.292.292h7a.293.293,0,0,0,.292-.292v-3.5a.293.293,0,0,0-.292-.292Z"
                  transform="translate(-0.208 -0.208)"
                  fill="#fff"
                />
                <path
                  id="Path_4099"
                  data-name="Path 4099"
                  d="M11.29,15.67,10.566,14.6h.3a.075.075,0,0,1,.047.012.1.1,0,0,1,.027.03l.572.878a.4.4,0,0,1,.032-.07l.54-.8a.186.186,0,0,1,.03-.036.058.058,0,0,1,.039-.012h.283l-.726,1.052.751,1.139h-.293a.079.079,0,0,1-.053-.017.176.176,0,0,1-.031-.038l-.588-.919a.316.316,0,0,1-.027.061l-.572.858a.21.21,0,0,1-.032.039.065.065,0,0,1-.05.018h-.275l.755-1.125Zm1.754.876h.948V16.8H12.747V14.6h.3Zm2.4-1.6a.117.117,0,0,1-.03.034.059.059,0,0,1-.039.012.111.111,0,0,1-.061-.026q-.042-.031-.086-.058a.805.805,0,0,0-.128-.057.558.558,0,0,0-.18-.026.575.575,0,0,0-.176.027.377.377,0,0,0-.128.073.279.279,0,0,0-.076.109.348.348,0,0,0-.026.134.243.243,0,0,0,.045.152.385.385,0,0,0,.119.1.952.952,0,0,0,.168.074l.193.065c.065.023.131.048.192.075a.658.658,0,0,1,.168.107.486.486,0,0,1,.12.158.515.515,0,0,1,.045.229.735.735,0,0,1-.049.269.632.632,0,0,1-.143.22.672.672,0,0,1-.231.146.849.849,0,0,1-.311.054.956.956,0,0,1-.389-.077.908.908,0,0,1-.3-.209l.086-.14a.107.107,0,0,1,.03-.029.07.07,0,0,1,.038-.012.118.118,0,0,1,.073.034.946.946,0,0,0,.1.076.608.608,0,0,0,.366.107.577.577,0,0,0,.188-.029.378.378,0,0,0,.258-.373.269.269,0,0,0-.045-.163.38.38,0,0,0-.118-.106.832.832,0,0,0-.167-.072l-.192-.061a2.009,2.009,0,0,1-.192-.073.608.608,0,0,1-.167-.109.484.484,0,0,1-.118-.164.571.571,0,0,1-.045-.244.579.579,0,0,1,.177-.418.622.622,0,0,1,.211-.134.75.75,0,0,1,.29-.05.921.921,0,0,1,.335.058.773.773,0,0,1,.264.169l-.072.141Z"
                  transform="translate(-3.765 -6.075)"
                  fill="#fff"
                />
              </g>
            </svg>
          </v-btn>
          <v-btn
            depressed
            width="45"
            height="45"
            @click="printNow(items, headers)"
            :color="$vuetify.theme.themes.light.dataActionBTN"
            dark
            fab
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18.116"
              height="18.116"
              viewBox="0 0 16.116 16.116"
            >
              <g
                id="Icon_feather-printer"
                data-name="Icon feather-printer"
                transform="translate(-2.5 -2.5)"
              >
                <path
                  id="Path_4011"
                  data-name="Path 4011"
                  d="M9,8.291V3h9.069V8.291"
                  transform="translate(-2.977)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                />
                <path
                  id="Path_4012"
                  data-name="Path 4012"
                  d="M6.023,20.3H4.512A1.512,1.512,0,0,1,3,18.791V15.012A1.512,1.512,0,0,1,4.512,13.5H16.6a1.512,1.512,0,0,1,1.512,1.512v3.779A1.512,1.512,0,0,1,16.6,20.3H15.093"
                  transform="translate(0 -5.209)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                />
                <path
                  id="Path_4013"
                  data-name="Path 4013"
                  d="M9,21h9.069v6.046H9Z"
                  transform="translate(-2.977 -8.931)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                />
              </g>
            </svg>
          </v-btn>
          <v-spacer class="top-spacer" />
        </div>
      </div>
      <div class="table__view" v-if="$store.state.views === 'table'">
        <table-component
          id="recieved-requests"
          :headers="headers"
          :items="items"
          :loading="loading"
          v-model="page"
          :showSelect="true"
          @refresh="get_requests"
          itemKey="id"
          :pagination="pagination"
          :selectedRows.sync="selected_requests"
        >
          <!-- eslint-disable -->
          <template v-slot:[`item.action`]="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="#3f0e40" depressed small dark v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <router-link
                  style="text-decoration: none"
                  :to="{ name: 'request_details', params: { id: item.id } }"
                >
                  <v-list-item>
                    <v-list-item-icon class="ml-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18.528"
                        height="15.111"
                        viewBox="0 0 13.528 10.111"
                      >
                        <g
                          id="Icon_feather-eye-dark"
                          data-name="Icon feather-eye-dark"
                          transform="translate(-1 -5.5)"
                        >
                          <path
                            id="Path_4040"
                            data-name="Path 4040"
                            d="M1.5,10.556S3.778,6,7.764,6s6.264,4.556,6.264,4.556-2.278,4.556-6.264,4.556S1.5,10.556,1.5,10.556Z"
                            fill="none"
                            :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                          />
                          <path
                            id="Path_4041"
                            data-name="Path 4041"
                            d="M16.917,15.208A1.708,1.708,0,1,1,15.208,13.5,1.708,1.708,0,0,1,16.917,15.208Z"
                            transform="translate(-7.444 -4.653)"
                            fill="none"
                            :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                          />
                        </g>
                      </svg>
                    </v-list-item-icon>
                    <v-list-item-title>فتح</v-list-item-title>
                  </v-list-item>
                </router-link>

                <v-list-item @click="getRequestCalls(item)">
                  <v-list-item-icon class="ml-3">
                    <RequestCallsIcon />
                  </v-list-item-icon>
                  <v-list-item-title>المكالمات</v-list-item-title>
                </v-list-item>

                <router-link
                  style="text-decoration: none"
                  target="_blank"
                  :to="{ name: 'request_details', params: { id: item.id } }"
                >
                  <v-list-item>
                    <v-list-item-icon class="ml-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18.528"
                        height="15.111"
                        viewBox="0 0 13.528 10.111"
                      >
                        <g
                          id="Icon_feather-eye-dark"
                          data-name="Icon feather-eye-dark"
                          transform="translate(-1 -5.5)"
                        >
                          <path
                            id="Path_4040"
                            data-name="Path 4040"
                            d="M1.5,10.556S3.778,6,7.764,6s6.264,4.556,6.264,4.556-2.278,4.556-6.264,4.556S1.5,10.556,1.5,10.556Z"
                            fill="none"
                            :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                          />
                          <path
                            id="Path_4041"
                            data-name="Path 4041"
                            d="M16.917,15.208A1.708,1.708,0,1,1,15.208,13.5,1.708,1.708,0,0,1,16.917,15.208Z"
                            transform="translate(-7.444 -4.653)"
                            fill="none"
                            :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                          />
                        </g>
                      </svg>
                    </v-list-item-icon>
                    <v-list-item-title> فتح في تاب جديد</v-list-item-title>
                  </v-list-item>
                </router-link>
                <v-list-item @click="to_tickets_page(item)">
                  <v-list-item-icon class="ml-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18.014"
                      viewBox="0 0 18 18.014"
                    >
                      <g id="ticket" transform="translate(-72.188 -72)">
                        <path
                          id="Path_2758"
                          data-name="Path 2758"
                          d="M89.062,76.532a.489.489,0,0,0-.622-.059,1.956,1.956,0,0,1-2.711-2.721.5.5,0,0,0-.059-.617l-.563-.563A1.96,1.96,0,0,0,83.723,72h0a1.959,1.959,0,0,0-1.385.573l-9.582,9.611a1.96,1.96,0,0,0,0,2.765l.377.372a.494.494,0,0,0,.656.034,1.941,1.941,0,0,1,2.736,2.731.489.489,0,0,0,.029.661l.695.695a1.961,1.961,0,0,0,2.77,0h0l9.592-9.592a1.961,1.961,0,0,0,0-2.77ZM79.323,88.747a.981.981,0,0,1-1.385,0l-.4-.4a2.916,2.916,0,0,0-4-4l-.083-.083a.981.981,0,0,1,0-1.385l6.523-6.548,5.882,5.882Zm9.592-9.592-2.369,2.369-5.882-5.887,2.359-2.369a.962.962,0,0,1,.69-.289h0a.978.978,0,0,1,.69.284l.3.3a2.939,2.939,0,0,0,3.93,3.93l.279.279a.976.976,0,0,1,0,1.385Z"
                          transform="translate(0)"
                          fill="#383c40"
                        />
                        <path
                          id="Path_2759"
                          data-name="Path 2759"
                          d="M169.609,216.41l-2.373-2.374a.981.981,0,0,0-1.385,0h0l-2.315,2.315a.981.981,0,0,0,0,1.385l2.374,2.373a.981.981,0,0,0,1.385,0l2.315-2.315a.969.969,0,0,0,.024-1.375C169.629,216.41,169.624,216.4,169.609,216.41Zm-3,3-2.378-2.373,2.315-2.315h0l2.373,2.373Z"
                          transform="translate(-86.606 -134.813)"
                          fill="#383c40"
                        />
                      </g>
                    </svg>
                  </v-list-item-icon>
                  <v-list-item-title>التذاكر</v-list-item-title>
                </v-list-item>
                <v-list-item @click="to_chat_page(item)">
                  <v-list-item-icon class="ml-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17.599"
                      height="18.22"
                      viewBox="0 0 17.599 18.22"
                    >
                      <g id="chat" transform="translate(-2.1 -1.2)">
                        <path
                          id="Path_2760"
                          data-name="Path 2760"
                          d="M11.565,37.775a3.256,3.256,0,0,0-2.366-1.6c-.769-.207-.739-.5-.71-.739l.059-.118a.029.029,0,0,1,.03-.03c.03-.059.089-.118.118-.177A1.807,1.807,0,0,0,8.9,34.7c.03-.059.03-.118.059-.177,0-.03.03-.059.03-.089l.089-.089.207-.237.03-.03a1.289,1.289,0,0,0,.177-.5v-.089c0-.089.03-.148.03-.237v-.177a.782.782,0,0,0-.3-.621.267.267,0,0,1,.03-.148,2.252,2.252,0,0,0,.089-.621,1.673,1.673,0,0,0-.237-.946,1.881,1.881,0,0,0-.8-.71c-.059-.03-.148-.059-.207-.089a3.218,3.218,0,0,0-1.183-.207H6.655a2.493,2.493,0,0,0-.887.177c-.03.03-.089.03-.089.059a1.023,1.023,0,0,0-.325.3l-.03.059c-.03.059-.03.059-.059.059a.394.394,0,0,1-.148.089.64.64,0,0,0-.355.325,1.889,1.889,0,0,0-.177.651,5.013,5.013,0,0,0,.03.651c0,.089.03.177.03.266v.03a.618.618,0,0,0-.325.621v.207c0,.089.03.177.03.237v.089a1.267,1.267,0,0,0,.148.473c.059.089.089.148.148.177a.784.784,0,0,0,.177.148,2.8,2.8,0,0,0,.325.739v.03l.03.03.059.089.03.03c.03.03.03.03.03.059l.03.03v.03c.03.207.089.5-.71.739a3.529,3.529,0,0,0-2.366,1.6,1.955,1.955,0,0,0-.148.769v.562a.392.392,0,0,0,.385.385h0a.392.392,0,0,0,.385-.385v-.532a1.854,1.854,0,0,1,.059-.473c.266-.621,1.183-.976,1.893-1.183q1.464-.4,1.242-1.6a.657.657,0,0,0-.148-.325l-.03-.03c0-.03-.03-.03-.03-.059L5.738,34.7a3.205,3.205,0,0,1-.237-.562.6.6,0,0,0-.237-.355l-.059-.03c-.03,0-.03-.03-.059-.059a.1.1,0,0,1-.03-.059.42.42,0,0,1-.059-.177l.059-.118c0-.059-.03-.118-.03-.177v-.089h.059l.089-.03a.462.462,0,0,0,.207-.385,1.746,1.746,0,0,0-.059-.414c0-.059-.03-.118-.03-.177a1.766,1.766,0,0,1,0-.562.636.636,0,0,1,.059-.3A1.221,1.221,0,0,0,5.738,31a.68.68,0,0,0,.207-.237l.03-.059a.231.231,0,0,1,.118-.118,2.1,2.1,0,0,1,.621-.118h.207a2.3,2.3,0,0,1,.917.177c.059.03.089.03.148.059a.821.821,0,0,1,.444.385,1.013,1.013,0,0,1,.118.532,2.589,2.589,0,0,1-.059.473,1.006,1.006,0,0,0-.03.3v.089a.505.505,0,0,0,.03.355.529.529,0,0,0,.3.266v.089a.375.375,0,0,1-.03.177.178.178,0,0,1-.03.118.25.25,0,0,1-.059.177l-.03.03-.059.03-.207.207a.879.879,0,0,0-.177.385c0,.03,0,.059-.03.059a2.748,2.748,0,0,1-.148.3c-.03.03-.03.059-.059.089l-.207.3a.557.557,0,0,0-.059.237q-.222,1.2,1.242,1.6a2.793,2.793,0,0,1,1.893,1.183,1.3,1.3,0,0,1,.059.473v.532a.373.373,0,0,0,.385.385h0a.392.392,0,0,0,.385-.385v-.562A1.135,1.135,0,0,0,11.565,37.775Zm-.237,1.568Zm8.37-.8a1.865,1.865,0,0,0-.148-.769,3.256,3.256,0,0,0-2.4-1.6c-.769-.207-.739-.5-.71-.739l.059-.148.03-.03c.03-.059.089-.118.118-.177a2.686,2.686,0,0,0,.207-.414,1.233,1.233,0,0,0,.059-.177V34.4c.03-.03.059-.059.089-.059l.03-.03.03-.03.177-.207.03-.03a1.289,1.289,0,0,0,.177-.5v-.089c0-.089.03-.148.03-.237v-.177a.782.782,0,0,0-.3-.621.267.267,0,0,1,.03-.148,2.607,2.607,0,0,0,.089-.621,1.673,1.673,0,0,0-.237-.946,1.881,1.881,0,0,0-.8-.71v-.03a.5.5,0,0,0-.148-.059,3.113,3.113,0,0,0-1.183-.207H14.67a2.06,2.06,0,0,0-.887.177c-.059.03-.089.059-.118.059a1.55,1.55,0,0,0-.325.3l-.03.089-.03.03a.029.029,0,0,1-.03.03.27.27,0,0,1-.148.089.64.64,0,0,0-.355.325,1.889,1.889,0,0,0-.177.651V32.1c0,.089.03.177.03.266v.03a.618.618,0,0,0-.325.621v.177a.912.912,0,0,0,.03.266v.089a2.216,2.216,0,0,0,.148.473c.059.059.089.148.148.177a.784.784,0,0,0,.177.148,2.43,2.43,0,0,0,.325.739v.03l.089.118.03.03c.03.03.03.03.03.059l.03.059c.03.207.089.5-.71.739a6.474,6.474,0,0,0-1.213.473l-.03.03a3.545,3.545,0,0,1,.5.621,5.782,5.782,0,0,1,.946-.355q1.464-.4,1.242-1.6a.657.657,0,0,0-.148-.325l-.03-.03c0-.03-.03-.03-.03-.059l-.118-.148a3.205,3.205,0,0,1-.237-.562.589.589,0,0,0-.237-.355l-.059-.03a.064.064,0,0,1-.059-.059.1.1,0,0,1-.03-.059.42.42,0,0,1-.059-.177l.089-.148c0-.059-.03-.118-.03-.177v-.089h.059l.089-.03a.4.4,0,0,0,.207-.385,1.79,1.79,0,0,0-.059-.444c0-.059-.03-.089-.03-.148a1.766,1.766,0,0,1,0-.562.742.742,0,0,1,.059-.3h0A1.99,1.99,0,0,0,13.724,31a1.293,1.293,0,0,0,.207-.237l.03-.059a.231.231,0,0,1,.118-.118,1.75,1.75,0,0,1,.592-.118h.207a2.3,2.3,0,0,1,.917.177c.059.03.089.03.148.059a.941.941,0,0,1,.444.385,1.013,1.013,0,0,1,.118.532,2.589,2.589,0,0,1-.059.473.819.819,0,0,0-.03.266v.089a.505.505,0,0,0,.03.355.529.529,0,0,0,.3.266v.089a.375.375,0,0,1-.03.177l-.03.118a.269.269,0,0,1-.089.207l-.03.089-.177.177a.842.842,0,0,0-.177.414c0,.03,0,.03-.03.059a1.363,1.363,0,0,1-.148.3c0,.03-.03.059-.059.089h-.03l-.089.148-.059.089v.059a.557.557,0,0,0-.059.237q-.222,1.2,1.242,1.6A2.793,2.793,0,0,1,18.87,38.1a1.34,1.34,0,0,1,.089.473v.532a.413.413,0,0,0,.089.266.321.321,0,0,0,.266.118h0a.373.373,0,0,0,.385-.385v-.118C19.7,38.6,19.7,38.544,19.7,38.544Z"
                          transform="translate(0 -20.07)"
                          fill="#383c40"
                        />
                        <path
                          id="Path_2761"
                          data-name="Path 2761"
                          d="M10.973,9.008a.467.467,0,0,1-.473-.473V3.359A2.168,2.168,0,0,1,12.659,1.2h.03c1.183.03,1.923,0,2.78,0h1.508a2.184,2.184,0,0,1,1.331.444,2.135,2.135,0,0,1,.858,1.627A4.13,4.13,0,0,1,18.9,5.1a3.371,3.371,0,0,1-.532.887A3.54,3.54,0,0,1,16.5,7.263a3.207,3.207,0,0,1-1.065.148H12.748L11.683,8.476l-.355.355A.416.416,0,0,1,10.973,9.008Zm1.686-7.069a1.444,1.444,0,0,0-1.449,1.42V7.973l1.035-1.035.03-.03a.584.584,0,0,1,.414-.177h2.751a3.849,3.849,0,0,0,.887-.118,3.017,3.017,0,0,0,1.479-1.035,2.622,2.622,0,0,0,.414-.739A4.216,4.216,0,0,0,18.427,3.3a1.346,1.346,0,0,0-.562-1.094,1.4,1.4,0,0,0-.887-.3H15.5c-.917.03-1.656.03-2.839.03Z"
                          transform="translate(-5.916)"
                          fill="#383c40"
                        />
                        <path
                          id="Path_2762"
                          data-name="Path 2762"
                          d="M41.568,3.511V8.6a.424.424,0,0,1-.148.325.445.445,0,0,1-.325.118.62.62,0,0,1-.325-.118l-.562-.562c-.3-.3-.562-.562-.769-.739H36.421a1.109,1.109,0,0,1-.325-.03l-.3-.03a5.069,5.069,0,0,0,.739-.651h2.928a.584.584,0,0,1,.414.177l.03.03.562.562.266.266.089.059v-4.5A1.3,1.3,0,0,0,39.5,2.21H37.279a2.04,2.04,0,0,0-.532-.71h2.78A2.035,2.035,0,0,1,41.568,3.511Z"
                          transform="translate(-23.732 -0.211)"
                          fill="#383c40"
                        />
                      </g>
                    </svg>
                  </v-list-item-icon>
                  <v-list-item-title>محادثة العميل</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template slot="item.cs_date" slot-scope="props">
            <request-table-date-cell :value="props.item.cs_date" />
          </template>
          <template slot="item.agent_date" slot-scope="props">
            <request-table-date-cell :value="props.item.agent_date" />
          </template>
          <template slot="item.agent_notes" slot-scope="props">
            <span v-if="!props.item.agent_notes"></span>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  props.item.agent_notes.substring(0, 25) + "..."
                }}</span>
              </template>
              <div class="font-weight-bold">{{ props.item.agent_notes }}</div>
            </v-tooltip>
          </template>
          <template slot="item.quality_notes" slot-scope="props">
            <span v-if="!props.item.quality_notes"></span>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  props.item.quality_notes.substring(0, 25) + "..."
                }}</span>
              </template>
              <div class="font-weight-bold">{{ props.item.quality_notes }}</div>
            </v-tooltip>
          </template>
          <template slot="item.source" slot-scope="props">
            {{ work_source(parseInt(props.item.source))
            }}{{ props.item.source == 2 ? ` - ${props.item.collaborator_name}` : "" }}
          </template>
          <template slot="item.customer_name" slot-scope="props">
            {{ props.item.customer.name }}
          </template>
        </table-component>
      </div>
      <div v-else-if="$store.state.views === 'default'">
        <div v-if="defaultViewData.length > 0">
          <DefaultView
            :CardData="defaultViewData"
            @pageCount="handlePageNumber"
            name="recieved"
          />
        </div>
        <div>
          <LoadingMore v-if="loadMoreData" style="margin: 40px" />
        </div>
      </div>
      <div v-else-if="$store.state.views === 'cards'">
        <CardsStyle :tableData="items" />
      </div>
      <!-- Crards -->
      <!-- <CardsStyle :tableData="items" /> -->
      <!-- Crards -->
    </div>

    <!--Ready State Table-->
    <div style="margin-bottom: 40px">
      <div
        :class="showTable == 2 ? 'mt-6' : 'mt-6 d-none'"
        v-if="$store.state.views === 'table'"
      >
        <h3>العملاء الجدد :</h3>
        <div
          class="printing mb-3"
          :style="readyStateReqData.length <= 0 ? 'display:none' : 'display:block'"
        >
          <v-app-bar
            color="white"
            style="box-shadow: 0px 0px 6px -4px black; border-radius: 10px"
            class="ml-sm-5"
          >
            <v-spacer class="top-spacer" />
            <v-btn
              depressed
              width="45"
              height="45"
              :color="$vuetify.theme.themes.light.dataActionBTN"
              dark
              fab
              class="ml-1 hidden-sm-and-down"
              @click="exportExcel_2"
              v-if="!$store.state.cardsStyle"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.116"
                height="18.116"
                viewBox="0 0 12.25 14"
              >
                <g id="excel-file" transform="translate(-1.5)">
                  <path
                    id="Path_4097"
                    data-name="Path 4097"
                    d="M11.708,14H1.792a.292.292,0,0,1-.292-.292V3.548a.292.292,0,0,1,.074-.194L4.491.1A.292.292,0,0,1,4.708,0h7A.292.292,0,0,1,12,.292V7a.292.292,0,0,1-.583,0V.583H4.839L2.083,3.659v9.757h9.333V12.25a.292.292,0,1,1,.583,0v1.458A.293.293,0,0,1,11.708,14Z"
                    fill="#fff"
                  />
                  <path
                    id="Path_4098"
                    data-name="Path 4098"
                    d="M4.917,4.292H2.292a.292.292,0,0,1,0-.583H4.625V.792a.292.292,0,0,1,.583,0V4A.292.292,0,0,1,4.917,4.292Zm8.167,8.167h-7a.876.876,0,0,1-.875-.875v-3.5a.876.876,0,0,1,.875-.875h7a.876.876,0,0,1,.875.875v3.5A.876.876,0,0,1,13.083,12.458Zm-7-4.667a.292.292,0,0,0-.292.292v3.5a.292.292,0,0,0,.292.292h7a.293.293,0,0,0,.292-.292v-3.5a.293.293,0,0,0-.292-.292Z"
                    transform="translate(-0.208 -0.208)"
                    fill="#fff"
                  />
                  <path
                    id="Path_4099"
                    data-name="Path 4099"
                    d="M11.29,15.67,10.566,14.6h.3a.075.075,0,0,1,.047.012.1.1,0,0,1,.027.03l.572.878a.4.4,0,0,1,.032-.07l.54-.8a.186.186,0,0,1,.03-.036.058.058,0,0,1,.039-.012h.283l-.726,1.052.751,1.139h-.293a.079.079,0,0,1-.053-.017.176.176,0,0,1-.031-.038l-.588-.919a.316.316,0,0,1-.027.061l-.572.858a.21.21,0,0,1-.032.039.065.065,0,0,1-.05.018h-.275l.755-1.125Zm1.754.876h.948V16.8H12.747V14.6h.3Zm2.4-1.6a.117.117,0,0,1-.03.034.059.059,0,0,1-.039.012.111.111,0,0,1-.061-.026q-.042-.031-.086-.058a.805.805,0,0,0-.128-.057.558.558,0,0,0-.18-.026.575.575,0,0,0-.176.027.377.377,0,0,0-.128.073.279.279,0,0,0-.076.109.348.348,0,0,0-.026.134.243.243,0,0,0,.045.152.385.385,0,0,0,.119.1.952.952,0,0,0,.168.074l.193.065c.065.023.131.048.192.075a.658.658,0,0,1,.168.107.486.486,0,0,1,.12.158.515.515,0,0,1,.045.229.735.735,0,0,1-.049.269.632.632,0,0,1-.143.22.672.672,0,0,1-.231.146.849.849,0,0,1-.311.054.956.956,0,0,1-.389-.077.908.908,0,0,1-.3-.209l.086-.14a.107.107,0,0,1,.03-.029.07.07,0,0,1,.038-.012.118.118,0,0,1,.073.034.946.946,0,0,0,.1.076.608.608,0,0,0,.366.107.577.577,0,0,0,.188-.029.378.378,0,0,0,.258-.373.269.269,0,0,0-.045-.163.38.38,0,0,0-.118-.106.832.832,0,0,0-.167-.072l-.192-.061a2.009,2.009,0,0,1-.192-.073.608.608,0,0,1-.167-.109.484.484,0,0,1-.118-.164.571.571,0,0,1-.045-.244.579.579,0,0,1,.177-.418.622.622,0,0,1,.211-.134.75.75,0,0,1,.29-.05.921.921,0,0,1,.335.058.773.773,0,0,1,.264.169l-.072.141Z"
                    transform="translate(-3.765 -6.075)"
                    fill="#fff"
                  />
                </g>
              </svg>
            </v-btn>
            <v-btn
              depressed
              width="45"
              height="45"
              @click="printNow_2"
              :color="$vuetify.theme.themes.light.dataActionBTN"
              dark
              fab
            >
              <v-icon size="20" color="white">mdi-printer</v-icon>
            </v-btn>
            <v-spacer class="top-spacer" />
          </v-app-bar>
        </div>
        <div class="table__view">
          <table-component
            id="customer-requests"
            :headers="headersTwo"
            :items="readyStateReqData"
            :loading="loadingTwo"
            itemKey="request_id"
            @refresh="receiveCutomers"
          >
            <!-- eslint-disable -->
            <template v-slot:[`item.action`]="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="#3f0e40" depressed small dark v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    style="cursor: pointer"
                    @click="$router.push({ name: 'chat_component' })"
                  >
                    <v-list-item-icon style="margin-left: 10px !important"
                      ><v-icon>mdi-chat</v-icon></v-list-item-icon
                    >
                    <v-list-item-title>الدردشة</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template slot="item.cs_date" slot-scope="props">
              <request-table-date-cell :value="props.item.cs_date" />
            </template>
            <template slot="item.agent_date" slot-scope="props">
              <request-table-date-cell :value="props.item.agent_date" />
            </template>
            <template slot="item.comment" slot-scope="props">
              <span v-if="!props.item.comment"></span>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ props.item.comment.substring(0, 25) + "..." }}</span>
                </template>
                <div class="font-weight-bold">{{ props.item.comment }}</div>
              </v-tooltip>
            </template>
            <template slot="item.quacomment" slot-scope="props">
              <span v-if="!props.item.quacomment"></span>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{
                    props.item.quacomment.substring(0, 25) + "..."
                  }}</span>
                </template>
                <div class="font-weight-bold">{{ props.item.quacomment }}</div>
              </v-tooltip>
            </template>
            <template slot="item.source" slot-scope="props">
              {{ props.item.source ? props.item.source["value"] : "" }}
            </template>
          </table-component>
        </div>
      </div>

      <!-- Test -->
      <CallsDialog />
      <AgentChat />
      <!-- Test -->
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import CallsDialog from "@/components/Charts/CallsDialog.vue";
import CardsStyle from "@/components/Base/CardsStyle.vue";
import AgentChat from "@/components/AgentChat/AgentChat.vue";
import { RequestCallsIcon } from "@/assets/adminIcons/requestCalls";
import DefaultView from "@/components/Base/DefaultView";
import LoadingMore from "@/components/Charts/LoadingMore";
import RequestTableDateCell from "@/components/common/RequestTableDateCell.vue";
import { REQUEST_TABLE_DATE_HEADERS } from "@/utils/requestTableDates";

export default {
  name: "HelloWorld",
  components: {
    CardsStyle,
    AgentChat,
    CallsDialog,
    RequestCallsIcon,
    DefaultView,
    LoadingMore,
    RequestTableDateCell,
  },
  data: () => ({
    loading: false,
    disabledBtn: false,
    page: 1,
    addNewRequestDialog: false,
    defaultViewData: [],
    loadMoreData: false,
    items: [],
    pagination: {
      limit: 12,
      count: 0,
    },
    selected_requests: [],
    headers: [
      // { text: "تاريخ الطلب", value: "req_date", align: "center", width: "120px" },
      { text: "نوع الطلب", value: "type", align: "center" },
      { text: "عميل", value: "customer_name", align: "center" },
      { text: "حالة الطلب", value: "status", align: "center" },
      // { text: "مصدر المعامله", value: "source", align: "center" },
      // { text: "تصنيف المعامله", value: "class_id_agent_text", align: "center" },
      // { text: "الملاحظه", value: "agent_notes", align: "center" },
      // { text: "ملاحظة الجوده", value: "quality_notes", align: "center" },
      ...REQUEST_TABLE_DATE_HEADERS,
      { text: "العمليات", value: "action", align: "center" },
    ],

    loadingTwo: false,
    readyToRecieve: "",
    readyLable: "",
    headersTwo: [
      { text: "تاريخ الرسالة", value: "message_at_date" },
      { text: "وقت الرسالة", value: "message_at_time" },
      { text: "نص الرسالة", value: "message_value" },
      { text: "العمليات", value: "action", width: "1%" },
    ],
    readyStateReqData: [],
    showTable: 1,
    showBtn: false,
    showBtnText: "طلبات قائمة الإنتظار",
  }),
  watch: {
    selected_requests(val) {
      this.$emit("requests", val);
    },
    page(val) {
      this.get_requests(val, "table");
    },

    // Task 146
    "$store.state.count_of_archived_in_quality": {
      handler(val) {
        if (val > this.$store.state.redirect_count_of_archived_in_quality && localStorage["role"] == "0") {
          this.$store.state.showAlertOfArchivedQualityDidntProccess = true;
          this.$router.push({ name: "archievedInQuality" });
        }
      },
      immediate: true
    },
    "$store.state.first_not_processed_task_id": {
      handler(val) {
        if (val > 0 && localStorage["role"] == "0") {
          this.$store.state.showAlertOfTasksDidntProccess = true;
          this.$router.push({ name: 'ticket_details', params: { ticket: this.$store.state.first_not_processed_task_id } });
        }
      },
      immediate: true 
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval != oldvalue) {
          this.get_requests(this.page);
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },
  },
  methods: {
    async get_all_requests(page = 1) {
      this.loading = true;
      await Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=all&page=${page}&per_page=12`,
        {
          headers: this.request_headers(),
        }
      ).then((response) => {
        this.pagination = {
          limit: 12,
          count: response.data.payload.count_of_all,
        };
        this.loading = false;
      });
    },

    getRequestCalls(item) {
      this.$store.state.idOfRequestCalls = item.id;
      this.$store.state.openCallsDialog = true;
    },

    itemRowBackground(item) {
      return item.type === "طلب تم فتحه" ? "style-1" : "style-2";
    },

    async ask_for_more_customers() {
      let url = `${this.$store.state.url}/agent/AskForMoreCustomers`;
      if (localStorage["role"] && localStorage["role"] == "0" && localStorage["is_customer_service"] && localStorage["is_customer_service"] == "1") {
        url = `${this.$store.state.url}/agent/AskForMoreCustomerServices`;
      }
      try {
        const response = await Axios.get(url, {
          headers: this.request_headers(),
        });
        // this.showPopup("success", "تم طلب مزيد من العملاء بنجاح");
        this.showPopup("success", response.data.message);

        await this.refreshReceivedAndWaiting();
      } catch (err) {
        this.showPopup("error", err?.response?.data?.message || err?.message || "حدث خطأ غير متوقع");
      }
    },

    /** Refresh received list and waiting list (same as after ask_for_more_customers / pull request) */
    async refreshReceivedAndWaiting() {
      this.defaultViewData = [];
      this.items = [];
      if (this.page !== 1) {
        this.page = 1;
      } else {
        await this.get_requests(1, "table");
      }
      if (this.showTable == 2 || this.readyToRecieve === true) {
        await this.receiveCutomers();
      }
    },

    //Switch Ready State
    async getReadyReceivingState() {
      await Axios.get(`${this.$store.state.url}/agent/ready-receive`, {
        headers: this.request_headers(),
      }).then(async (res) => {
        if (res.data.payload === 0) {
          this.readyToRecieve = false;
          this.disabledBtn = true;
          this.showBtn = false;
          await this.receiveCutomers();
        } else {
          this.readyToRecieve = true;
          this.showBtn = true;
          this.disabledBtn = false;
        }
        this.changeState(this.readyToRecieve);
      });
    },
    async switchReadyState() {
      let body = { agent_statue: this.readyToRecieve ? 1 : 0 };

      await Axios.put(`${this.$store.state.url}/agent/ready-receive`, body, {
        headers: this.request_headers(),
      })
        .then((res) => {
          if (this.readyToRecieve) {
            this.showPopup(
              "success",
              " بتشغيلك لهذه الخاصية يعني انك جاهز لستلام رسائل فوريه والرد عليها بشكل فوري لعملاء جدد من موقعنا"
            );
          } else {
            this.showPopup(
              "success",
              res.data.message + " , الان لايمكنك استلام رسائل فوريه من عملائنا"
            );
          }
          this.changeState(this.readyToRecieve);
        })
        .then(async () => {
          if (this.readyToRecieve) {
            this.showBtn = true;
            await this.receiveCutomers();
          } else {
            this.showBtn = false;
            this.showTable = 1;
            this.showBtnText = "طلبات قائمة الإنتظار";
          }
        })
        .catch((err) => {
          this.showPopup("error", err.response.data.message);
        });
    },
    async receiveCutomers() {
      this.loadingTwo = true;
      await Axios.get(`${this.$store.state.url}/agent/waiting-list`, {
        headers: this.request_headers(),
      }).then((res) => {
        this.loadingTwo = false;
        this.readyStateReqData = [];
        res.data.payload.forEach((body) => {
          body.message_at_date = new Date(body.message_at)
            .toLocaleDateString()
            .split("/")
            .reverse()
            .join("/");
          body.message_at_time = new Date(body.message_at).toLocaleTimeString();
          if (body.message_type != "text") {
            body.message_value = "تم ارسال ملف";
          }
          this.readyStateReqData.push(body);
        });
      });
    },
    handlePageNumber(val) {
      this.get_requests(val);
    },
    toggleTables() {
      if (this.showTable == 1) {
        this.showTable = 2;
        this.showBtnText = "عرض جدول الطلبات المستلمة";
        this.$store.state.cardsStyle = false;
        document.querySelector(".separatorr").style.cssText = `
          display: none !important
        `;
      } else {
        this.showTable = 1;
        this.showBtnText = "طلبات قائمة الإنتظار";
        document.querySelector(".separatorr").style.cssText = `
          block: none !important
        `;
      }
    },
    async pullRequest(reqId) {
      try {
        const response = await Axios.post(
          `${this.$store.state.url}/agent/transfer-request?request_id=${reqId}`,
          {},
          { headers: this.request_headers() }
        );
        this.showPopup("success", response?.data?.message || "تم سحب الطلب بنجاح");
        await this.refreshReceivedAndWaiting();
      } catch (err) {
        this.showPopup("error", err?.response?.data?.message || err?.message || "حدث خطأ");
      }
    },
    changeState(val) {
      if (val) {
        this.readyLable = "جاهز لاستلام عملاء جدد";
        setTimeout(() => {
          document.querySelector(".v-input .v-label").style.color = "#2f4395";
        }, 100);
      } else {
        this.readyLable = "غير جاهز لاستلام عملاء جدد";
        setTimeout(() => {
          document.querySelector(".v-input .v-label").style.color = "rgb(155 178 215)";
        }, 100);
      }
    },
    //End Switch Ready State

    async get_requests(page = 1, type) {
      this.loading = true;
      this.loadMoreData = true;
      await Axios.get(
        `${this.$store.state.url}/v2/employee/Requests?type=received&page=${page}&per_page=${this.$store.state.counterOfShow}`,
        {
          headers: this.request_headers(),
        }
      ).then((response) => {
        const data = response?.data?.payload?.data || [];

        // Table view renders `items`
        if (page === 1 || type === "table") {
          this.items = data;
        }

        // Default view renders `defaultViewData` and uses infinite scrolling
        if (page === 1) {
          this.defaultViewData = data;
        } else {
          this.defaultViewData.push(...data);
        }
        this.pagination = {
          limit: 12,
          count: response.data.payload.count_of_received,
        };
        this.loading = false;
        this.loadMoreData = false;
      });
    },
    to_request_details(item) {
      this.$router.push({
        name: "request_details",
        params: { id: item.id },
      });
    },
    to_tickets_page(item) {
      this.$router.push({ name: "tickets", params: { id: item.id } });
    },
    exportExcel() {
      const table = document.querySelector("#recieved-requests");
      this.exportTableToCsv(table, "الطلبات المستلمة");
    },
    printNow() {
      this.items.forEach((data) => {
        data.customer_name = data.customer.name;
      });
      this.printTable(this.items, this.headers, "جدول الطلبات المستلمة");
    },

    exportExcel_2() {
      const table = document.querySelector("#customer-requests");
      this.exportTableToCsv(table, "طلبات العملاء الجدد");
    },
    printNow_2() {
      this.printTable(
        this.readyStateReqData,
        this.headersTwo,
        "جدول طلبات العملاء الجدد"
      );
    },
    to_chat_page(item) {
      this.$router.push({
        name: "chat_component",
        query: {
          customer_name: item.customer.name,
          customer_id: item.customer.id,
          request_id: item.id,
        },
      });
    },
  },
  async created() {
    this.$store.state.opened = -1;
    await this.getReadyReceivingState();
  },
  async mounted() {
    await this.get_requests();
    this.$root.$on("REFRESHCARDDATA", this.refreshReceivedAndWaiting);
  },
  beforeDestroy() {
    this.$root.$off("REFRESHCARDDATA", this.refreshReceivedAndWaiting);
  },
};
</script>

<style lang="scss">
.v-input .v-label {
  font-size: 20px;
  margin-right: 16px;
  margin-bottom: 3px;
}
@media (max-width: 990px) {
  .btns-dad {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 11px;
  }
}
@media (max-width: 600px) {
  .receive-btn {
    font-size: 13px !important;
  }
}

.style-1 {
  background-color: rgb(215, 215, 44);
}
.style-2 {
  background-color: rgb(114, 114, 67);
}
</style>
